import "./TermsOfUse.module.css";
import TermsOfUseContent from "./sections/TermsOfUseContent";
import Footer from "@/reusable_sections/Footer";
export default function TermsOfUsePage() {
  return <div>
      <TermsOfUseContent />
      <Footer />
    </div>;
}